/**
 * getErrorMessage(err) → string en español, SIEMPRE.
 *
 * Mapea el shape canónico de error de los endpoints nuevos
 * { error: { code, message, details } } y los legacy a un string. Nunca
 * devuelve un objeto: renderizar un objeto de error crudo rompe React (#31).
 */
/** El que pone middleware/validate.js cuando falla el esquema: no dice qué falla. */
const GENERIC_VALIDATION_MESSAGE = 'Datos inválidos';

const CODE_TO_MESSAGE = {
  VALIDATION_ERROR: 'Los datos enviados no son válidos.',
  FORBIDDEN: 'No tienes permisos para realizar esta acción.',
  NOT_FOUND: 'El recurso solicitado no existe.',
  INTERNAL_ERROR: 'Ha ocurrido un error. Inténtalo de nuevo en unos momentos.',
};

const GENERIC = 'Ha ocurrido un error. Inténtalo de nuevo.';
const NETWORK = 'No se pudo conectar con el servidor. Comprueba tu conexión.';

export function getErrorMessage(err) {
  if (!err) return GENERIC;

  if (err.response) {
    const data = err.response.data;
    if (data?.error?.code) {
      // Un VALIDATION_ERROR con motivo propio («Falta el texto del primer SMS»)
      // se enseña tal cual: el genérico lo tapaba y nadie sabía qué corregir.
      // Solo el de middleware/validate.js, sin motivo, va al texto genérico.
      const { code, message } = data.error;
      if (code === 'VALIDATION_ERROR' && message && message !== GENERIC_VALIDATION_MESSAGE) return message;
      return CODE_TO_MESSAGE[code] || message || GENERIC;
    }
    if (typeof data?.error === 'string') return data.error;
    if (typeof data === 'string') return data;
    if (err.response.status === 403) return CODE_TO_MESSAGE.FORBIDDEN;
    if (err.response.status === 404) return CODE_TO_MESSAGE.NOT_FOUND;
    return GENERIC;
  }

  if (err.request) return NETWORK;
  if (err.message) return err.message;
  return GENERIC;
}

export default getErrorMessage;
